import {
    useState, useEffect, useParams, useNavigate, useDispatch, titleToUrl,
    giftCover1, giftCover2, giftCover3, giftCover4, giftCover5, giftCover6, giftCover7, giftCover8
} from "../../imports/generalImport";
import { Box, Container } from "../../imports/muiImport";
import { createDenominationData, fetchProductById, isDenominationAvailable, isProductLive, validateOutOfStock } from './productDetailHook';

// components
import PageBreadcrumb from "../../components/other/PageBreadcrumb";
import GiftCardSectionSkeleton from './GiftCardSectionSkeleton';
import ProductDetailCard from './productUtils/ProductDetailCard';
import ProductDetailTabView from './productUtils/ProductDetailTabView';
import { setProductDetails, wipeOutProductDetails } from '../../store/productInfo/action';
import { setNewDenomination, wipeOutDenomination } from '../../store/productDetails/action';
import { Helmet } from 'react-helmet-async';
import ThreeGiftCard from '../DASHBOARD/ThreeGiftCard';
import PageNotFound from '../OTHERPAGE/PageNotFound';
import { isDiscountedProduct } from "../../hooks/utilsFn/utilsFn";
import { addPost, resetPosts, setSelectedPost } from "../../store/giftcardDesign/action";


const defaultForTestingPurposeTemplates = [
    { id: 1, image: giftCover1, altText: "Gift Cover 1", title: '', isTemplate: true, isDeleteable: false, isDefault: false, isSelected: false },
    { id: 2, image: giftCover2, altText: "Gift Cover 2", title: '', isTemplate: true, isDeleteable: false, isDefault: false, isSelected: false },
    { id: 3, image: giftCover3, altText: "Gift Cover 3", title: '', isTemplate: true, isDeleteable: false, isDefault: false, isSelected: false },
    { id: 4, image: giftCover4, altText: "Gift Cover 4", title: '', isTemplate: true, isDeleteable: false, isDefault: false, isSelected: false },
    { id: 5, image: giftCover5, altText: "Gift Cover 5", title: '', isTemplate: true, isDeleteable: false, isDefault: false, isSelected: false },
    { id: 6, image: giftCover6, altText: "Gift Cover 6", title: '', isTemplate: true, isDeleteable: false, isDefault: true, isSelected: true },
    { id: 7, image: giftCover7, altText: "Gift Cover 7", title: '', isTemplate: true, isDeleteable: false, isDefault: false, isSelected: false },
    { id: 8, image: giftCover8, altText: "Gift Cover 8", title: '', isTemplate: true, isDeleteable: false, isDefault: false, isSelected: false },
];


function ProductDetail() {
    // States Initialize
    const [productDetail, setProductDetail] = useState([]);  // store current product details
    const [outOfStock, setOutOfStock] = useState(null);  // verify and set this products is out of stock
    const [rangeDenomination, setRangeDenomination] = useState(false); // set range field or not'
    const [productFound, setProductFound] = useState(false);
    const [cpId, setCPId] = useState(0);
    let { title: urlTitle, id: urlId } = useParams();
    const canonicalUrl = `https://www.99gift.in/card-details/${urlId}/${titleToUrl(urlTitle)}`;
    const [pageLoading, setPageLoading] = useState(true);

    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        // check to product is available or not
        if (urlId != cpId) {
            dispatch(wipeOutProductDetails()); // clear product Details 
            getProductByTitle(urlId, urlTitle);
            dispatch(wipeOutDenomination()); // clear previous denomination
            dispatch(resetPosts())
            setCPId(urlId);
        } else {
            // Redirect to home page
            navigate('/');
        }
    }, [urlId, urlTitle]);

    if (productFound) {
        return (<PageNotFound />);
    }

    return (
        <>
            <Helmet>
                <title>
                    {productDetail?.['metaSEO']?.['metaTitle'] ?
                        (productDetail?.['metaSEO']?.['metaTitle']) :
                        (`Buy ${urlTitle} - 99gift.in`)
                    }
                </title>

                <meta
                    property="og:title"
                    content={
                        productDetail?.['metaSEO']?.['metaOGTitle'] ?
                            (productDetail?.['metaSEO']?.['metaOGTitle']) :
                            (`Buy ${urlTitle} - 99gift.in`)
                    }
                />

                <meta
                    name="description"
                    content={
                        productDetail?.['metaSEO']?.['metaDescription'] ?
                            (productDetail?.['metaSEO']?.['metaDescription']) :
                            (`Get instant discounts on ${urlTitle} when you purchase them online through 99gift. Take advantage of great deals on ${urlTitle}, coupons, and promo codes.`)
                    }
                />

                <meta
                    name="og:description"
                    content={
                        productDetail?.['metaSEO']?.['metaOGDescription'] ?
                            (productDetail?.['metaSEO']?.['metaOGDescription']) :
                            (`Get instant discounts on ${urlTitle} when you purchase them online through 99gift. Take advantage of great deals on ${urlTitle}, coupons, and promo codes.`)
                    }
                />

                <meta property="og:url" content={canonicalUrl} />
                <link rel="canonical" href={canonicalUrl} />

                {
                    productDetail?.['metaSchema']
                    &&
                    (
                        <script type="application/ld+json">
                            {productDetail?.['metaSchema']}
                        </script>
                    )
                }

                <meta
                    name="twitter:card"
                    content="summary"
                />
                <meta
                    name="twitter:title"
                    content={productDetail?.['metaSEO']?.['metaTitle']}
                />
                <meta
                    name="twitter:description"
                    content={productDetail?.['metaSEO']?.['metaDescription']}
                />
                <meta
                    name="twitter:image"
                    content={productDetail?.image}
                />
                <meta
                    name="twitter:url"
                    content={canonicalUrl}
                />
            </Helmet>

            <Container
                maxWidth="xl"
                sx={{
                    // backgroundColor: "white.main",
                    px: { xs: 0, sm: 2 },
                }}
            >
                <PageBreadcrumb
                    home="Home"
                    category={productDetail?.category?.title}
                    currentProduct={productDetail?.title}
                />


                <Box
                    sx={{
                        backgroundColor: "transparent",
                        backgroundAttachment: "fixed",
                    }}
                >
                    <ProductDetailCard pageLoading={pageLoading} />

                    <ProductDetailTabView
                        pageLoading={pageLoading}
                        productDetail={productDetail}
                        rangeDenomination={rangeDenomination}
                        outOfStock={outOfStock}
                    />
                </Box>

                {/* {allProducts.length && (<ProductSuggestionCard products={allProducts} />)} */}


                <Box sx={{ pb: 4 }}>
                    {!pageLoading ? (
                        <ThreeGiftCard
                            title="You might be interested in"
                            giftCardData={productDetail.like}
                            mbackgroundColor="transparent"
                            fixSlideView={true}
                            design={{
                                boxShadow: {
                                    sm: 0,
                                    md: 0,
                                },
                            }}
                        />
                    ) :
                        <GiftCardSectionSkeleton />
                    }
                </Box>

            </Container>
        </>
    );


    async function getProductByTitle(urlId, urlTitle) {
        setPageLoading(true);
        try {
            const actualData = await fetchProductById(urlId);
            let mainData = {};

            const validateProductTitleResponse = validateProductTitle(actualData?.data, urlTitle);
            const { productType, discount } = isDiscountedProduct(actualData?.data?.discount, actualData?.data?.cashback_amount);

            if (actualData?.status && validateProductTitleResponse) {
                mainData = actualData?.data;
                setProductDetail(mainData);
                mainData.productType = productType;
                mainData.discount = discount;
                mainData.isCashbackProduct = productType === 'Cashback';

                // Task 1
                /***
                 * Check Product is InStock or OutOf Stock 
                 */
                // first check product is available or not 
                const isProductLiveStatus = isProductLive(mainData.front);
                mainData.outOfStock = isProductLiveStatus


                const isRange = actualData?.data.isRange;
                // const apiId = actualData?.data.api_id;
                const front = actualData?.data.front;
                const denom = actualData?.data?.denomination;
                const validateResponse = validateOutOfStock(isRange, front, denom);
                // const validateResponse = validateOutOfStock(apiId, front, denom);


                if (validateResponse.outOfStockStatus) {
                    mainData.outOfStock = true;
                }
                if (validateResponse.rangeDenominationStatus) {
                    mainData.rangeDenomination = true;
                }


                // -----------END -----------

                /**
                 * ***********************************************
                 * ***********************************************
                 * ***********************************************
                 * ***********************************************
                 * ***********************************************
                 */

                // Task 2
                /***
                 * Check product denomination available or not 
                 */
                const isDenoAvailable = isDenominationAvailable(mainData?.["denomination"]);
                if (isDenoAvailable?.isDenominationAvailableStatus) {
                    mainData.rangeDenomination = false;

                    // denomination data set into redux store
                    const newDeno = createDenominationData(mainData);
                    dispatch(setNewDenomination(newDeno));
                } else {
                    mainData.rangeDenomination = true;
                }
                // -----------END -----------
            } else {
                // Invalid Response so redirect to home page
                setProductFound(true);
            }


            // mainData.isShowGiftDesignOption = true; // for testing setting this value true

            // TODO : Create a function to store default templates in gift card design predefined templates
            dispatch(setProductDetails(mainData));

            if (mainData?.isShowGiftDesignOption) {
                const predefinedTemplates = mainData?.predesignedTemplates || [];
                // const predefinedTemplates = defaultForTestingPurposeTemplates;
                if (predefinedTemplates?.length > 0) {
                    predefinedTemplates?.forEach(element => {
                        const post = {
                            id: element?.id,
                            image: element?.img,
                            altText: element?.altText || `Gift Cover ${element?.id}`,
                            title: element?.title || '',
                            isTemplate: element?.isTemplate || true,
                            isDeleteable: element?.isDeleteable || false,
                            isDefault: element?.isDefault || false,
                            isSelected: element?.isSelected || false,
                        }
                        dispatch(addPost(post));
                    });

                    const findDefault = predefinedTemplates?.find((item) => item.isDefault === true);
                    const defaultSelectedPost = {
                        id: findDefault?.id,
                        image: findDefault?.image,
                        altText: findDefault?.altText || `Gift Cover ${findDefault?.id}`,
                        title: findDefault?.title || '',
                        isTemplate: findDefault?.isTemplate || true,
                        isDeleteable: findDefault?.isDeleteable || false,
                        isDefault: findDefault?.isDefault || false,
                        isSelected: findDefault?.isSelected || false,
                    }

                    dispatch(setSelectedPost(defaultSelectedPost || predefinedTemplates[0]));
                }
            }

            setPageLoading(false);
            return null;
        } catch (error) {
            console.error(error);
            console.error("something Went Wrong !");
        }
    }


    function validateProductTitle(actualData, urlTitle) {
        const userGivenTitle = urlTitle.toLowerCase();
        const ourProductTitle = actualData?.title.toLowerCase();
        const ourFinalTitle = titleToUrl(ourProductTitle);

        if (ourFinalTitle === userGivenTitle) {
            setProductFound(false);
            return true;
        } else {
            setProductFound(true);
            return true;
        }
    }
}
export default ProductDetail

